<template>
  <ChartCard>
    <ChartHeader label>
      <v-skeleton-loader
        type="text"
        min-width="90%"
        height="20px"
      />
    </ChartHeader>
    <div v-for="i in 5" :key="i" class="d-flex align-center justify-start mb-2 source-fill-rate-loader-row">
      <DpplSkeletonLoader class="mr-2">
        <div class="colored-dot-loader" />
      </DpplSkeletonLoader>
      <v-skeleton-loader class="mr-3" type="text" height="12px" width="290px" />
      <v-skeleton-loader type="text" height="12px" width="290px" />
      <v-skeleton-loader type="text" height="12px" width="44px" class="ml-auto" />
    </div>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

.source-fill-rate-loader-row {
  height: 52px;
  padding: 12px;
  width: 100%;
}

.colored-dot-loader {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: fade(@grey-900, 15%);
}
</style>
